import Bus from '@/core/message-bus'
import store from '@/store'
import utils from '@/core/utils'

export function showMandatoryCommentModal({ mandatoryComment, title }) {
  return new Promise((resolve, reject) => {
    Bus.publish('modal.show.mandatory-comments', {
      title,
      mandatoryComment,
      addComments: (data) => {
        resolve(data)
        Bus.publish('modal.hide.mandatory-comments')
      },
      resetFunction: () => {
        resolve()
      }
    })
  })
}

export async function showComplementUserDetailsModal() {
  const hasLoggedIn = utils.getQueryStringParam('hasLoggedIn')
  if(hasLoggedIn) {
    utils.removeQueryParam('hasLoggedIn')
    const user = store.getters.clientModel.user

    const isMissingUserDetails = !user.firstName || !user.lastName || !user.userPhone || (user.isMultiUser && !user.companyPhone)
    const hasDissmissedModal = sessionStorage.getItem('userDetailsModalClosed')
    const isImpersonating = store.getters.clientModel.impersonating

    if(isMissingUserDetails && !hasDissmissedModal && !isImpersonating) {
      Bus.publish('modal.show.user-details')
    }
  }
}

export function showMyMachinesGdprConsentModal() {
  return new Promise((resolve) => {
    Bus.publish('modal.show.mymachine-consent-gdpr', {
      confirmConsent: () => {
        resolve(true)
        Bus.publish('modal.hide.mymachine-consent-gdpr')
      },
      declineConsent: () => {
        resolve(false)
        Bus.publish('modal.hide.mymachine-consent-gdpr')
      }
    })
  })
}

export function showDownloadsPriceListConsentModal() {
  return new Promise((resolve) => {
    Bus.publish('modal.show.downloads-pricelist-consent', {
      confirmConsent: () => {
        resolve(true)
        Bus.publish('modal.hide.downloads-pricelist-consent')
      },
      declineConsent: () => {
        resolve(false)
        Bus.publish('modal.hide.downloads-pricelist-consent')
      }
    })
  })
}
